<template>
  <div class="SchedulingScorePanel">
    <div class="form_box">
      <div class="form_box__group__item">
        <div class="form_box__group__item__title">修改学时</div>
        <div class="form_box__group__item__content ml-10">
            <el-input v-model="credithour" placeholder="输入学时信息" type="number"></el-input>
        </div>
        <div class="form_box__group__item__tool"></div>
      </div>
    </div>
    <div class="mt-5 ml-2"> 
        <el-button type="primary" :loading="loading" @click="onClickUpdate">更新</el-button>
    </div>
  </div>
</template>

<script>

import {
  schedulingEditScoreApi,
  schedulingEditInitApi
} from "@/api/module/scheduling/scheduling"


export default {
  name: "schedulinglocation",
  props:{
    timetype:{
      type: Number
    }
  },
  data() {
    return {
      // edit scope
      id : null,
      credithour : 0,
      loading : false
    }
  },
  methods:{
    init() {
      let id = this.$route.query.id;
      if(id){
        this.id = id;
        schedulingEditInitApi(id)
          .then((r)=>{
            // 初始化选中的
            console.log("schedulingEditInitApi",r)

            // this.courses = r.courses;
            this.credithour = r.credithour;

          })
      }
    },

    onClickUpdate(){
      this.loading = true;
      this.$message.info("更新中")
      
      schedulingEditScoreApi(
          this.id,
          this.credithour
        )
        .then((r)=>{

          this.$message.success("更新成功")
          this.init();
        })
        .finally(()=>{
          this.loading = false;
        })
    }
  },
  mounted(){
    this.init();
  }
}
</script>




<style scoped>

</style>